export const LocationSVG = () => {
  return (
    <svg
      className="scale-125"
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13C12 12.7348 11.8946 12.4804 11.7071 12.2929C11.5196 12.1054 11.2652 12 11 12Z"
        fill="#3D515A"
      />
      <path
        d="M11 8H7C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9C6 9.26522 6.10536 9.51957 6.29289 9.70711C6.48043 9.89464 6.73478 10 7 10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8Z"
        fill="#3D515A"
      />
      <path
        d="M11 4H7C6.73478 4 6.48043 4.10536 6.29289 4.29289C6.10536 4.48043 6 4.73478 6 5C6 5.26522 6.10536 5.51957 6.29289 5.70711C6.48043 5.89464 6.73478 6 7 6H11C11.2652 6 11.5196 5.89464 11.7071 5.70711C11.8946 5.51957 12 5.26522 12 5C12 4.73478 11.8946 4.48043 11.7071 4.29289C11.5196 4.10536 11.2652 4 11 4Z"
        fill="#3D515A"
      />
      <path
        d="M17 22H16V1C16 0.734784 15.8946 0.48043 15.7071 0.292893C15.5196 0.105357 15.2652 0 15 0L3 0C2.73478 0 2.48043 0.105357 2.29289 0.292893C2.10536 0.48043 2 0.734784 2 1V22H1C0.734784 22 0.48043 22.1054 0.292893 22.2929C0.105357 22.4804 0 22.7348 0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24H17C17.2652 24 17.5196 23.8946 17.7071 23.7071C17.8946 23.5196 18 23.2652 18 23C18 22.7348 17.8946 22.4804 17.7071 22.2929C17.5196 22.1054 17.2652 22 17 22ZM8 22V19C8 18.7348 8.10536 18.4804 8.29289 18.2929C8.48043 18.1054 8.73478 18 9 18C9.26522 18 9.51957 18.1054 9.70711 18.2929C9.89464 18.4804 10 18.7348 10 19V22H8ZM12 22V19C12 18.2044 11.6839 17.4413 11.1213 16.8787C10.5587 16.3161 9.79565 16 9 16C8.20435 16 7.44129 16.3161 6.87868 16.8787C6.31607 17.4413 6 18.2044 6 19V22H4V2H14V22H12Z"
        fill="#3D515A"
      />
    </svg>
  );
};
